import { IFieldsMap } from "@common/redux/formBuilder/interface";
import { getFieldsMapOfActiveFormSelector } from "@common/redux/formBuilder/selectors";
import { IInfographicsWidgetDataServer } from "@common/redux/forms/interface";
import { FieldProps } from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { useSelector } from "react-redux";
import { IBaseTableData, IData, IDataList, tableType } from "../interface";
import { transformFieldSubmissionValues } from "./transformFieldSubmissionValues";

export const getTableType = (
  widgetData: IInfographicsWidgetDataServer
): tableType => {
  if (widgetData?.filterSettings?.groupBy?.length > 0) return "ADVANCED";
  return "BASIC";
};

export const getFieldValue = (field, value) => {
  return transformFieldSubmissionValues(
    field.fieldType,
    value,
    field?.fieldValue?.options ?? field?.fieldConfig?.options ?? {}
  );
};

export const advancedTableData = (dataList: IData[], fieldsMap: IFieldsMap) => {
  const tableObject = [];
  for (const item of dataList) {
    let dataSet = {};
    const fieldData = item._id;
    const keysList = Object.keys(fieldData);
    dataSet = {
      ...item,
      _type: "ADVANCED",
    };
    delete dataSet["_id"];
    if (keysList.length === 1) {
      dataSet["formData"] = {};
      const fieldName = fieldsMap[keysList[0]]?.title;
      dataSet["formData"]["fieldName"] = fieldName;
      dataSet["formData"]["fieldValue"] = getFieldValue(
        fieldsMap[keysList[0]],
        fieldData[keysList[0]]
      );
    }
    tableObject.push(dataSet);
  }
  return tableObject;
};

export const basicTableData = (
  dataList: IBaseTableData[],
  fieldsMap: IFieldsMap
) => {
  const tableObject = [];

  for (const data of dataList) {
    if (data.formData) {
      const dataSet = {
        _type: "BASIC",
      };
      const formData = data.formData;
      const formDataKeys = Object.keys(formData);
      for (const key of formDataKeys) {
        const fieldName = fieldsMap?.[key]?.title;
        if (!fieldName) continue;
        dataSet[fieldName] = getFieldValue(fieldsMap[key], formData[key]);
      }
      tableObject.push(dataSet);
    }
  }
  return tableObject;
};

export const transformServerToClientTableData = (
  data: IDataList,
  widgetData: IInfographicsWidgetDataServer,
  fieldsMapData: IFieldsMap
) => {
  const fields = Object.keys(fieldsMapData ?? {});
  if (fields.length === 0) return [];
  const widegetId = widgetData.localId;
  let tableObject = [];
  if (widgetData.type === "TABLE") {
    const tableType = getTableType(widgetData);
    const dataList = data?.[widegetId];
    if (dataList && tableType === "ADVANCED") {
      tableObject = advancedTableData(dataList as IData[], fieldsMapData);
    } else if (dataList) {
      tableObject = basicTableData(dataList as IBaseTableData[], fieldsMapData);
    }
  }
  return tableObject;
};
